import { DetailsFieldActionSkeleton } from './details-field-action-skeleton';
import { DetailsSkeletonBlock } from './details-skeleton-block';

const ConversationFieldControlSkeleton = ({
  hasExternalAction = false,
}: {
  hasExternalAction?: boolean;
}) => (
  <div className="flex items-center gap-3">
    <div className="relative flex-1">
      <DetailsSkeletonBlock className="h-[34px] w-full rounded-xl bg-secondary-100" />
      <DetailsSkeletonBlock className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 rounded bg-secondary-200" />
    </div>

    {hasExternalAction && <DetailsFieldActionSkeleton />}
  </div>
);

export const ConversationFieldRowSkeleton = ({ index }: { index: number }) => (
  <div className="space-y-0.5 py-1.5">
    <DetailsSkeletonBlock className="h-3 w-20" />
    <ConversationFieldControlSkeleton hasExternalAction={index === 3} />
  </div>
);
